import { createEnv } from "@poscon/shared-types";

const envKeys = ["VITE_ERAM_SERVER_URL", "VITE_SENTRY_URL_VSCS", "VITE_STRATUS_FACILITY_DATA_URL"] as const;
const partialEnvKeys = ["VITE_VSCS_SECTOR_ID"] as const;

export const env = createEnv(import.meta.env, envKeys, partialEnvKeys);
